import React from 'react'
import "./RestaurantItem.css"
import { Link } from "react-router-dom"
import { useSelector } from 'react-redux'

function RestaurantItem({ restaurant }) {
    const darkModeState = useSelector(state => state.darkModeReducer.isDarkMode)

    return (
        <Link to={`/restaurantItem/${restaurant.id}`}>
            <div className='restaurant-item' style={{ border: `1px solid ${darkModeState ? "#FFF6EE": "#101720"}` }}>
                <div>
                    <img alt="restaurant-item" className='restaurant-item-image' src={restaurant.image_url} />
                </div>
                <div className='restaurant-details'>
                    <p style={{ color:  darkModeState ? '#FFF6EE': '#101720' }} className='restaurant-name'>{restaurant.name}</p>
                    <p className='restaurant-second-text'>Fast Food</p>
                    <div className='d-flex'>
                        <i className="fa-regular fa-star restaurant-rating"></i>
                        <p className="restaurant-item-rating-text" style={{ color:  darkModeState ? '#FFF6EE': '#101720' }}>{restaurant.user_rating.rating} <span>({restaurant.user_rating.total_reviews} ratings)</span></p>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default RestaurantItem